(function(){
function initSlcot(root){
  var d=root.dataset;var sym=d.sym||'$';var minq=parseInt(d.min,10)||1;
  var data={};try{data=JSON.parse(root.querySelector('[data-cotz]').textContent||'{}');}catch(e){}
  var pres=(data.presentaciones||[]);var cols=(data.colores||[]);var grupos=(data.opciones||[]);
  if(!pres.length){pres=[{label:'',tiers:data.tiers||[[null,0]]}];}
  var qEl=root.querySelector('[data-qty]'),totEl=root.querySelector('[data-total]'),cta=root.querySelector('[data-cta]'),tiersEl=root.querySelector('[data-tiers]');
  var sel={pres:0,color:(cols[0]?cols[0].n:''),vid:d.defvid||'',opts:{}};
  function fmt(n){return sym+Number(n).toLocaleString('es-CO');}
  function tiers(){return pres[sel.pres].tiers;}
  function tierIndex(q){var t=tiers();for(var i=0;i<t.length;i++){if(t[i][0]===null||q<=t[i][0])return i;}return t.length-1;}
  function unit(q){return tiers()[tierIndex(q)][1];}
  function buildTiers(){
    var t=tiers();var html='';var prev=0;
    for(var i=0;i<t.length;i++){
      var hi=t[i][0];var range=(hi===null)?(prev+1)+'+':(prev+1)+'–'+hi;
      var badge=(i===1&&d.b2)?d.b2:((i===t.length-1&&d.bb)?d.bb:'');
      html+='<div class="slcot__tier" data-ti="'+i+'">'+(badge?'<span class="slcot__tbadge">'+badge+'</span>':'')+'<div class="slcot__tq">'+range+'</div><div class="slcot__tu">Unidades</div><div class="slcot__tp">'+fmt(t[i][1])+' c/u</div></div>';
      prev=hi;
    }
    tiersEl.innerHTML=html;
  }
  function optsText(){
    var parts=[];
    for(var k in sel.opts){if(sel.opts.hasOwnProperty(k)){parts.push(k+': '+sel.opts[k]);}}
    if(sel.color){parts.unshift((d.optlabel||'Color/sabor')+': '+sel.color);}
    return parts.length?parts.join(' | '):'-';
  }
  function render(){
    var q=parseInt(qEl.value,10);if(isNaN(q)||q<minq){q=minq;}
    var i=tierIndex(q),u=unit(q),total=q*u;
    totEl.textContent=fmt(total);
    root.querySelectorAll('.slcot__tier').forEach(function(el,idx){el.classList.toggle('active',idx===i);});
    var pl=pres[sel.pres].label||'-';
    var msg=d.tpl.replace('{producto}',d.product).replace('{presentacion}',pl).replace('{opciones}',optsText()).replace('{sabor}',sel.color||optsText()).replace('{cantidad}',q).replace('{precio}',fmt(u)).replace('{total}',fmt(total));
    cta.href='https://wa.me/'+d.wa+'?text='+encodeURIComponent(msg);
  }
  if(pres.length>1&&pres[0].label){
    var pw=root.querySelector('[data-preswrap]');pw.style.display='';
    var pc=root.querySelector('[data-pres]');var pn=root.querySelector('[data-presname]');
    pres.forEach(function(pr,idx){
      var c=document.createElement('span');c.className='slcot__chip'+(idx===0?' active':'');c.textContent=pr.label;
      c.addEventListener('click',function(){
        pc.querySelectorAll('.slcot__chip').forEach(function(x){x.classList.remove('active');});
        c.classList.add('active');sel.pres=idx;if(pr.vid)sel.vid=pr.vid;if(pn)pn.textContent=' '+pr.label;buildTiers();render();
      });
      pc.appendChild(c);
    });
    if(pres[0].vid)sel.vid=pres[0].vid;if(pn)pn.textContent=' '+pres[0].label;
  }
  if(cols.length){
    var ow=root.querySelector('[data-optwrap]');ow.style.display='';
    if(d.optlabel){ow.querySelector('.slcot__optlabel').firstChild.textContent=d.optlabel;}
    var sw=root.querySelector('[data-swatches]');var onm=root.querySelector('[data-optname]');
    cols.forEach(function(co,idx){
      var el=document.createElement('span');var isChip=!co.hex;el.className=(isChip?'slcot__chip':'slcot__sw')+(idx===0?' active':'');if(isChip){el.textContent=co.n;}else{el.style.background=co.hex;el.title=co.n;}
      el.addEventListener('click',function(){
        sw.querySelectorAll('.slcot__sw,.slcot__swatches .slcot__chip').forEach(function(x){x.classList.remove('active');});
        el.classList.add('active');sel.color=co.n;if(co.vid)sel.vid=co.vid;if(onm)onm.textContent=' '+co.n;render();
      });
      sw.appendChild(el);
    });
    if(cols[0].vid)sel.vid=cols[0].vid;if(onm)onm.textContent=' '+cols[0].n;
  }
  if(grupos.length){
    var gwrap=root.querySelector('[data-optgroups]');
    grupos.forEach(function(g){
      var vals=g.values||[];if(!vals.length)return;
      sel.opts[g.label]=vals[0].n;
      var block=document.createElement('div');block.className='slcot__optgrp';
      var lab=document.createElement('label');lab.className='slcot__optlabel';lab.textContent=g.label;
      var nameSpan=document.createElement('span');nameSpan.textContent=' '+vals[0].n;lab.appendChild(nameSpan);
      var cont=document.createElement('div');cont.className='slcot__swatches';
      block.appendChild(lab);block.appendChild(cont);gwrap.appendChild(block);
      vals.forEach(function(co,idx){
        var el=document.createElement('span');var isChip=!co.hex;el.className=(isChip?'slcot__chip':'slcot__sw')+(idx===0?' active':'');
        if(isChip){el.textContent=co.n;}else{el.style.background=co.hex;el.title=co.n;}
        el.addEventListener('click',function(){
          cont.querySelectorAll('.slcot__sw,.slcot__chip').forEach(function(x){x.classList.remove('active');});
          el.classList.add('active');sel.opts[g.label]=co.n;nameSpan.textContent=' '+co.n;render();
        });
        cont.appendChild(el);
      });
    });
  }
  root.querySelectorAll('.slcot__tabbtn').forEach(function(b){b.addEventListener('click',function(){
    root.querySelectorAll('.slcot__tabbtn').forEach(function(x){x.classList.remove('active');});
    root.querySelectorAll('.slcot__panel').forEach(function(x){x.classList.remove('active');});
    b.classList.add('active');root.querySelector('.slcot__panel[data-panel="'+b.getAttribute('data-tab')+'"]').classList.add('active');
  });});
  function buildProps(){var p={};var pl=pres[sel.pres]&&pres[sel.pres].label;if(pl){p[d.preslabel||'Presentacion']=pl;}if(sel.color){p[d.optlabel||'Opcion']=sel.color;}for(var k in sel.opts){if(sel.opts.hasOwnProperty(k)){p[k]=sel.opts[k];}}return p;}
function addToCart(go){var q=parseInt(qEl.value,10);if(isNaN(q)||q<minq){q=minq;}if(!sel.vid){return;}
    var bs=root.querySelectorAll('[data-addcart],[data-buynow]');bs.forEach(function(b){b.disabled=true;b.style.opacity=.6;});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(sel.vid,10),quantity:q,properties:buildProps()}]})}).then(function(r){return r.json();}).then(function(){window.location=go;}).catch(function(){bs.forEach(function(b){b.disabled=false;b.style.opacity=1;});});}
  var ac=root.querySelector('[data-addcart]');if(ac)ac.addEventListener('click',function(){addToCart('/cart');});
  var bn=root.querySelector('[data-buynow]');if(bn)bn.addEventListener('click',function(){addToCart('/checkout');});
  qEl.addEventListener('input',render);
  buildTiers();render();
}
function boot(){document.querySelectorAll('.slcot').forEach(function(r){if(r.dataset.slcotReady)return;r.dataset.slcotReady='1';initSlcot(r);});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
document.addEventListener('shopify:section:load',boot);
})();
